import { render, staticRenderFns } from "./CustomerBlock.vue?vue&type=template&id=22e310b9&scoped=true&"
import script from "./CustomerBlock.vue?vue&type=script&lang=js&"
export * from "./CustomerBlock.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBlock.vue?vue&type=style&index=0&id=22e310b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e310b9",
  null
  
)

export default component.exports